import { Match, MatchMetaModel } from "../../../../api/repositories/stats/models/matches"
import { localize } from "../../../../common/services/localization"
import { toDateWithTime, getMinutesOrDefault } from "../../../../common/utils"

export const MatchMetaBlock: React.FC<{
    className: string
    meta: MatchMetaModel
}> = ({ meta, className }) => {
    const blockClassName = "flex flex-col gap-[6px] uppercase font-['Roboto']"
    const blockTextTitleClassName = "text-gray text-[12px] md:text-[14px]"
    const blockTextClassName = "text-[14px] md:text-[16px]"

    return <div>
        <div className={`grid grid-cols-2 sm:flex sm:grid-cols-0  sm:flex sm:flex-row gap-[14px] sm:gap-[0px] justify-between w-screen 2xl:w-full ${className}`}>
            <div className={`${blockClassName}`}>
                <div className={`${blockTextTitleClassName}`}>
                    {localize('match_meta_map')}
                </div>
                <div className={`${blockTextClassName}`}>
                    {meta.map}
                </div>
            </div>
            <div className={`${blockClassName}`}>
                <div className={`${blockTextTitleClassName}`}>
                    {localize('match_meta_season')}
                </div>
                <div className={`${blockTextClassName}`}>
                    {meta.season}

                </div>
            </div>
            <div className={`${blockClassName}`}>
                <div className={`${blockTextTitleClassName}`}>
                    {localize('match_meta_createdAt')}
                </div>
                <div className={`${blockTextClassName}`}>
                    {toDateWithTime(meta.createdAt)}
                </div>
            </div>
            <div className={`${blockClassName}`}>
                <div className={`${blockTextTitleClassName}`}>
                    {localize('status')}
                </div>
                <div className={`${blockTextClassName}`}>
                    {localize(`match_status_${meta.isFinished.toString()}`)}
                </div>
            </div>
            <div className={`${blockClassName}`}>
                <div className={`${blockTextTitleClassName}`}>
                    {localize('match_meta_duration')}
                </div>
                <div className={`${blockTextClassName}`}>
                    {getMinutesOrDefault(meta.durationAtSeconds)}
                </div>
            </div>
        </div>
    </div>
}